import { render, staticRenderFns } from "./PartnerViewer.vue?vue&type=template&id=8b4170fe"
import script from "./PartnerViewer.vue?vue&type=script&lang=js"
export * from "./PartnerViewer.vue?vue&type=script&lang=js"
import style0 from "./PartnerViewer.vue?vue&type=style&index=0&id=8b4170fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports